import { useEffect } from 'react'

import { fastdom } from 'utils/fastdom'

import { useScreenSize } from './useScreenSize'

/**
 * - height: 100vh is include the top and bottom bars
 * - --app-height will recalculate that value and use it in CSS
 */
function useAppHeight() {
  const { isMobile } = useScreenSize()
  useEffect(() => {
    const doc = document.documentElement
    const setAppHeight = () => {
      fastdom.mutate(() => {
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
      })
    }
    if (isMobile) {
      setAppHeight()
      window.addEventListener('resize', setAppHeight, {
        passive: true,
      })
      return () => window.removeEventListener('resize', setAppHeight)
    } else {
      fastdom.mutate(() => {
        doc.style.removeProperty('--app-height')
      })
    }
  }, [isMobile])
}

export const AppHeightListener = () => {
  useAppHeight()
  return null
}
